import { useLayoutEffect } from "react"

export const useSameHeightElements = (queryRef, querySelector) => {
  useLayoutEffect(() => {
    const elements = queryRef.current.querySelectorAll(querySelector)
    const setTheSameHeightElements = () => {
      elements.forEach(element => {
        element.style.height = `unset`
      })
      const greatestHeightElement = [...elements].reduce(
        (accumulator, currentElement) =>
          accumulator.offsetHeight > currentElement.offsetHeight
            ? accumulator
            : currentElement
      )
      elements.forEach(element => {
        element.style.height = `${greatestHeightElement.offsetHeight}px`
      })
    }
    setTheSameHeightElements()
    window.addEventListener("resize", setTheSameHeightElements)
    return () => window.removeEventListener("resize", setTheSameHeightElements)
  }, [queryRef, querySelector])
}
